import { createIndexReading as createIndexReadingAPI } from "../API/IndexReadings";
import { store } from "../store";

/**
 * Crée un nouveau relevé d'index et met à jour le store Redux
 * @param {string} dev_eui - EUI du device
 * @param {Object} data - Données du relevé
 * @returns {Promise<Object>} - Relevé créé
 */
export default async function createIndexReading(dev_eui, data) {
  try {
    const result = await createIndexReadingAPI(dev_eui, data);

    // Ajoute le nouveau relevé au store Redux
    store.dispatch({
      type: "indexReadings/addReading",
      payload: {
        dev_eui: dev_eui,
        reading: result,
      },
    });

    return result;
  } catch (error) {
    console.error("Erreur lors de la création du relevé:", error);
    throw error;
  }
}
